import { useNavigate } from 'react-router-dom';
import { useMe } from '@shared/hooks/use-me';
import { Button } from '@/components/ui/button';
import { useAuthStore } from '@shared/stores/auth-store';
import { getTokenStore } from '@shared/api/token-store';

export function MenuPage() {
  const navigate = useNavigate();
  const { data: me } = useMe();
  const signOut = useAuthStore((s) => s.signOut);

  function handleLogout() {
    getTokenStore().clear();
    signOut();
    navigate('/login');
  }

  const menuSections = [
    {
      title: 'Services & Workspace',
      items: [
        {
          label: 'Home Dashboard',
          sub: 'Overview and status summary',
          path: '/client/home',
          icon: (
            <svg
              className="w-5 h-5"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M2.25 12l8.954-8.955c.44-.439 1.152-.439 1.591 0L21.75 12M4.5 9.75v10.125c0 .621.504 1.125 1.125 1.125H9.75v-4.875c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125V21h4.125c.621 0 1.125-.504 1.125-1.125V9.75M8.25 21h8.25"
              />
            </svg>
          ),
        },
        {
          label: 'Services Catalog',
          sub: 'Browse legal and tax products',
          path: '/client/services',
          icon: (
            <svg
              className="w-5 h-5"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M13.5 21v-7.5a.75.75 0 01.75-.75h3a.75.75 0 01.75.75V21m-4.5 0H2.36m11.14 0H18m0 0h3.64m-1.39 0V9.349m-16.5 11.65V9.35m0 0a3.001 3.001 0 003.75-.615A2.993 2.993 0 009.75 9.75c.896 0 1.7-.393 2.25-1.016a2.993 2.993 0 002.25 1.016c.896 0 1.7-.393 2.25-1.015a3.001 3.001 0 003.75.614m-16.5 0a3.004 3.004 0 01-.621-4.72L4.318 3.44A1.5 1.5 0 015.378 3h13.243a1.5 1.5 0 011.06.44l1.19 1.189a3 3 0 01-.621 4.72m-13.5 8.65h3.75a.75.75 0 00.75-.75V13.5a.75.75 0 00-.75-.75H6.75a.75.75 0 00-.75.75v5.25c0 .414.336.75.75.75z"
              />
            </svg>
          ),
        },
        {
          label: 'My Orders & Chats',
          sub: 'Track filings and chat with associates',
          path: '/client/chat',
          icon: (
            <svg
              className="w-5 h-5"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M8.625 12a.375.375 0 11-.75 0 .375.375 0 01.75 0zm0 0H8.25m4.125 0a.375.375 0 11-.75 0 .375.375 0 01.75 0zm0 0H12m4.125 0a.375.375 0 11-.75 0 .375.375 0 01.75 0zm0 0h-.375M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z"
              />
            </svg>
          ),
        },
        {
          label: 'Document Wallet',
          sub: 'Store Aadhaar, PAN, Licence & legal files',
          path: '/client/wallet',
          icon: (
            <svg
              className="w-5 h-5 text-emerald-600"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
              />
              <path strokeLinecap="round" strokeLinejoin="round" d="M9 12h6m-3-3v6" />
            </svg>
          ),
        },
        {
          label: 'Loan EMI Calculator',
          sub: 'Calculate monthly payments, interest & repayment schedule',
          path: '/client/emi-calculator',
          icon: (
            <svg
              className="w-5 h-5 text-teal-600"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M15.75 15.75V18m-3-2.25V18m-3-2.25V18m9-6V9M15 9V6.75M12 9V6.75M9 9V6.75M4.5 19.5h15a2.25 2.25 0 002.25-2.25V6.75A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25v10.5A2.25 2.25 0 004.5 19.5z"
              />
            </svg>
          ),
        },
      ],
    },
    {
      title: 'Account Settings',
      items: [
        {
          label: 'Profile / KYC Info',
          sub: 'View details and identity status',
          path: '/client/profile',
          icon: (
            <svg
              className="w-5 h-5"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M15 9h3.75M15 12h3.75M15 15h3.75M4.5 19.5h15a2.25 2.25 0 002.25-2.25V6.75A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25v10.5A2.25 2.25 0 004.5 19.5zm6-10.125a1.875 1.875 0 11-3.75 0 1.875 1.875 0 013.75 0zm1.294 6.336a6.721 6.721 0 01-3.17.789 6.721 6.721 0 01-3.168-.789 3.376 3.376 0 016.338 0z"
              />
            </svg>
          ),
        },
        {
          label: 'Font Preference',
          sub: 'Adjust font size for better readability',
          path: '/client/font-preference',
          icon: <span className="font-extrabold text-sm tracking-tighter select-none">AA</span>,
        },
      ],
    },
  ];

  return (
    <div className="w-full max-w-2xl px-4 py-6 sm:px-6 pb-24">
      {/* Profile summary header */}
      <div className="flex items-center gap-4 bg-gradient-to-r from-brand-700 to-teal-800 rounded-2xl p-5 text-white shadow-md select-none">
        <div className="flex h-16 w-16 shrink-0 items-center justify-center rounded-xl bg-white/10 text-2xl font-bold shadow-inner sm:h-14 sm:w-14 sm:text-xl">
          {`${me?.firstName?.[0] ?? ''}${me?.lastName?.[0] ?? ''}`.toUpperCase() || 'US'}
        </div>
        <div className="min-w-0">
          <h2 className="text-lg font-extrabold truncate sm:text-base">
            {me?.firstName} {me?.lastName}
          </h2>
          <p className="text-sm text-brand-100 truncate mt-0.5 sm:text-xs">{me?.email}</p>
          <div className="mt-2 inline-flex items-center gap-1 bg-white/15 px-2 py-0.5 rounded-full text-xs font-bold tracking-wide uppercase sm:text-[10px]">
            Client Account
          </div>
        </div>
      </div>

      {/* Navigation Groups */}
      <div className="mt-8 space-y-6">
        {menuSections.map((sect, sIdx) => (
          <div key={sIdx}>
            <h3 className="text-xs font-bold uppercase tracking-wider text-gray-400 px-1 sm:text-[11px]">
              {sect.title}
            </h3>

            <ul className="mt-2.5 bg-white border border-gray-150 rounded-2xl divide-y divide-gray-100 overflow-hidden shadow-xs">
              {sect.items.map((item, iIdx) => (
                <li key={iIdx}>
                  <button
                    onClick={() => navigate(item.path)}
                    className="flex w-full items-center justify-between p-4 text-left transition-colors duration-150 hover:bg-gray-50 active:bg-gray-100 group"
                  >
                    <div className="flex items-center gap-3.5 min-w-0">
                      <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-brand-50 text-brand-750 group-hover:bg-brand-700 group-hover:text-white transition-all duration-200 shadow-sm">
                        {item.icon}
                      </div>
                      <div className="min-w-0">
                        <p className="text-base font-bold text-gray-900 group-hover:text-brand-850 sm:text-sm">
                          {item.label}
                        </p>
                        <p className="text-sm text-gray-400 mt-0.5 sm:text-xs">{item.sub}</p>
                      </div>
                    </div>
                    <svg
                      className="w-5 h-5 text-gray-300 group-hover:text-brand-600 transition-colors duration-150"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2.5"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M8.25 4.5l7.5 7.5-7.5 7.5"
                      />
                    </svg>
                  </button>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>

      {/* Log out option */}
      <div className="mt-8">
        <Button
          variant="outline"
          block
          className="rounded-2xl border-red-200 text-red-600 hover:bg-red-50 hover:text-red-700 hover:border-red-300 font-bold text-base sm:text-sm py-5 shadow-xs"
          onClick={handleLogout}
        >
          Logout Account
        </Button>
      </div>
    </div>
  );
}
